import { createSelector } from '@reduxjs/toolkit'
import { Nullish, RootState, WidgetTypes } from 'types'
import { FEATURE_NAME, IState } from '../Init.model'

export const selectInitSlice = (state: RootState): IState => state.app[FEATURE_NAME]

export const selectWidgetType = createSelector(
  selectInitSlice,
  (slice): Nullish<WidgetTypes> => slice.widgetType,
)

export const selectWidgetTitle = createSelector(
  selectInitSlice,
  (slice): Nullish<string> => slice.title,
)

export const selectWidgetTitleFontSize = createSelector(
  selectInitSlice,
  (slice): number => slice.titleFontSize,
)

export const selectSeeAllScoresButton = createSelector(
  selectInitSlice,
  (slice): boolean => slice.seeAllScoresButton,
)

export const selectBackgroundImage = createSelector(
  selectInitSlice,
  (slice): Nullish<string> => slice.backgroundImage,
)
